module.exports = __webpack_public_path__ + "img/bg2.aaaf400.png";